/* Product cards: clicking a colour swaps the card photo to that colour and
   points Add to cart + the product links at that colour's variant. */
(function () {
  function withVariant(url, variantId) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('variant', variantId);
      return u.pathname + u.search;
    } catch (e) {
      return url;
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-lushe-color]');
    if (!btn) return;

    var card = btn.closest('.card-wrapper');
    var group = btn.closest('[data-lushe-card-colors]');
    if (!card || !group) return;

    event.preventDefault();
    event.stopPropagation();

    // Selected state
    group.querySelectorAll('[data-lushe-color]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });

    // Swap the main photo (if this colour has its own photo)
    var src = btn.getAttribute('data-image-src');
    if (src) {
      var img = card.querySelector('.card__media img');
      if (img) {
        img.removeAttribute('loading');
        img.srcset = btn.getAttribute('data-image-srcset') || '';
        img.src = src;
        var alt = btn.getAttribute('data-image-alt');
        if (alt) img.alt = alt;
      }
      // The hover photo belongs to the original colour, so stop showing it
      card.classList.add('lushe-card--color-picked');
    }

    // Stock line for this colour (same wording and thresholds as the server)
    var stockLine = card.querySelector('[data-lushe-card-stock]');
    var units = parseInt(btn.getAttribute('data-stock-units'), 10);
    if (stockLine && !isNaN(units)) {
      var state = units <= 0 ? 'out' : units <= 5 ? 'low' : 'ok';
      var label = units <= 0 ? 'Out of stock' : units <= 5 ? 'Only ' + units + ' left in stock' : 'In stock';
      stockLine.className = stockLine.className.replace(/lushe-stock--(ok|low|out)/, 'lushe-stock--' + state);
      var textEl = stockLine.querySelector('.lushe-stock__text');
      if (textEl) textEl.textContent = label;
    }

    // Open Add to cart / links on this colour
    var variantId = btn.getAttribute('data-variant-id');
    if (variantId) {
      var base = group.getAttribute('data-product-url') || '';
      var addButton = card.querySelector('.quick-add__submit[data-product-url]');
      if (addButton) addButton.setAttribute('data-product-url', withVariant(base, variantId));

      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.setAttribute('href', withVariant(a.getAttribute('href'), variantId));
      });

      var idInput = card.querySelector('form input.product-variant-id');
      if (idInput && !addButton) idInput.value = variantId;
    }
  });
})();
